export default {
  UPDATE_PAGE_LIST: 'UPDATE_PAGE_LIST',
  UPDATE_FILTERED_SCREENSHOTS: 'UPDATE_FILTERED_SCREENSHOTS',
  SET_UPDATING: 'SET_UPDATING',
  UPDATE_PAGE_PARAMS: 'UPDATE_PAGE_PARAMS',
  UPDATE_EXPLORER_FILTER: 'UPDATE_EXPLORER_FILTER',
  ADD_DATE_FILTER: 'ADD_DATE_FILTER',
  REMOVE_DATE_FILTER: 'REMOVE_DATE_FILTER',
  CHANGE_DATE_FILTER_TYPE: 'CHANGE_DATE_FILTER_TYPE',
  SET_FILTERS_FROM_LINK: 'SET_FILTERS_FROM_LINK',
  SET_SCREENSHOTS_LIST_ISUPDATING: 'SET_SCREENSHOTS_LIST_ISUPDATING',
};
